<template>
  <div class="change-password">
    <div
      v-loading="loadingChangePassword"
      class="ch-change-password-card"
    >
      <el-form
        ref="form"
        :model="form"
        inline
        :rules="rules"
        label-width="160px"
        :label-position="labelPosition"
      >
        <div>
          <el-form-item label="賬戶登入電郵：">
            <span class="ch-form-item-text">{{ userInfo.email }}</span>
          </el-form-item>
        </div>
        <div>
          <el-form-item
            label="舊密碼："
            prop="oldPassword"
            class="form-item-width"
          >
            <el-input
              v-model="form.oldPassword"
              placeholder="請輸入舊密碼"
              show-password
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            label="新密碼："
            prop="newPassword"
            class="form-item-width"
          >
            <el-input
              v-model="form.newPassword"
              placeholder="請輸入6-20位英文及數字"
              show-password
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item
            label="再次輸入新密碼："
            prop="confirmedNewPassword"
            class="form-item-width"
          >
            <el-input
              v-model="form.confirmedNewPassword"
              placeholder="請再次輸入新密碼"
              show-password
            />
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <div slot="label">
&#8195;
            </div>
            <el-button
              type="primary"
              class="ch-button-blue-2"
              @click="onSubmit"
            >
              提交
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'ChangePassword',
    data: function () {
      return {
        form: {
          oldPassword: null,
          newPassword: null,
          confirmedNewPassword: null,
        },
        minPasNum: 6,
        maxPasNum: 20,
        labelPosition: 'right',
        loadingChangePassword: false,
        rules: {
          oldPassword: [
            {
              required: true,
              message: '舊密碼必填',
              trigger: 'blur'
            },
          ],
          newPassword: [
            {
              required: true,
              message: '新密碼必填',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value.length < this.minPasNum || value.length > this.maxPasNum) {
                  callback(new Error(`密碼須在${this.minPasNum}位到${this.maxPasNum}之間`))
                } else if (value === this.form.oldPassword) {
                  callback(new Error(`新舊密碼應當不同`))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          confirmedNewPassword: [
            {
              required: true,
              message: '驗證密碼必填',
              trigger: 'blur'
            },
            {
              validator: (rule, value, callback) => {
                if (value.length < this.minPasNum || value.length > this.maxPasNum) {
                  callback(new Error(`密碼須在${this.minPasNum}位到${this.maxPasNum}之間`))
                } else if (value !== this.form.newPassword) {
                  callback(new Error('兩次輸入的密碼不一致'))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
        }
      }
    },
    computed: {
      ...mapGetters(['userInfo'])
    },
    methods: {
      onSubmit() {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            let data = {
              oldPassword: this.form.oldPassword,
              newPassword: this.form.newPassword,
            }
            this.loadingChangePassword = true
            let res = await this.axios.post(this.pub.getApi().ChangePassword, data)
            this.loadingChangePassword = false
            if (res.data.code === 0) {
              this.$message({message: '密碼修改成功！', type: 'success', showClose: true, duration: 3000})
              this.pub.setCookie('dEVaUDFrZ1kd0RA', res.data.result.token)
              this.$router.go(-1)
            } else {
              this.$message({message: '密碼修改失敗，請重試！', type: 'error', showClose: true, duration: 3000})
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .change-password {
    text-align: left;
    width: 100%;
    .ch-change-password-card{
      background: #FFFFFF;
      border-radius: 20px;
      padding: 30px 50px;
    }
  }

  /deep/ .el-input__inner {
    width: 600px;
  }

  .ch-button-blue-2{
    border: 1px solid #0062FF;
    border-radius: 10px;
    color: #FFFFFF;
    background: #0062FF;
    width: 100px;
  }

</style>
